export type PanelRole = 'editor' | 'admin' | 'saas_admin';

export type PanelCapability =
  | 'content.pages.edit'
  | 'content.pages.delete'
  | 'content.collections.manage'
  | 'content.media.manage'
  | 'site.appearance.edit'
  | 'site.contact.edit'
  | 'site.languages.manage'
  | 'site.legal.edit'
  | 'site.domain.view'
  | 'site.domain.manage'
  | 'ops.bookings.manage'
  | 'ops.leads.view'
  | 'ops.reputation.manage'
  | 'marketing.surveys.manage'
  | 'marketing.surveys.view'
  | 'visibility.edit'
  | 'reputation.google.connect'
  | 'assistant.view'
  | 'assistant.config.edit'
  | 'assistant.model.set'
  | 'assistant.usage.tokens.view'
  | 'assistant.usage.cost.view'
  | 'assistant.conversations.view'
  | 'settings.view'
  | 'settings.publication.edit'
  | 'settings.publication.infrastructure.edit'
  | 'tenant.users.manage'
  | 'tenant.publish'
  | 'billing.view'
  | 'billing.manage'
  | 'platform.ai.config'
  | 'platform.security.config'
  | 'platform.legal.config'
  | 'platform.notifications.manage'
  | 'platform.support.config'
  | 'platform.credentials.config'
  | 'platform.plugins.manage'
  | 'plugins.view'
  | 'plugins.manage';

const CAPABILITY_ROLES: Record<PanelCapability, readonly PanelRole[]> = {
  'content.pages.edit': ['editor', 'admin', 'saas_admin'],
  'content.pages.delete': ['admin', 'saas_admin'],
  'content.collections.manage': ['editor', 'admin', 'saas_admin'],
  'content.media.manage': ['editor', 'admin', 'saas_admin'],
  'site.appearance.edit': ['editor', 'admin', 'saas_admin'],
  'site.contact.edit': ['editor', 'admin', 'saas_admin'],
  'site.languages.manage': ['admin', 'saas_admin'],
  'site.legal.edit': ['admin', 'saas_admin'],
  'site.domain.view': ['admin', 'saas_admin'],
  'site.domain.manage': ['saas_admin'],
  'ops.bookings.manage': ['editor', 'admin', 'saas_admin'],
  'ops.leads.view': ['editor', 'admin', 'saas_admin'],
  'ops.reputation.manage': ['editor', 'admin', 'saas_admin'],
  'marketing.surveys.manage': ['admin', 'saas_admin'],
  'marketing.surveys.view': ['editor', 'admin', 'saas_admin'],
  'visibility.edit': ['editor', 'admin', 'saas_admin'],
  'reputation.google.connect': ['admin', 'saas_admin'],
  'assistant.view': ['admin', 'saas_admin'],
  'assistant.config.edit': ['admin', 'saas_admin'],
  'assistant.model.set': ['saas_admin'],
  'assistant.usage.tokens.view': ['admin', 'saas_admin'],
  'assistant.usage.cost.view': ['saas_admin'],
  'assistant.conversations.view': ['admin', 'saas_admin'],
  'settings.view': ['admin', 'saas_admin'],
  'settings.publication.edit': ['admin', 'saas_admin'],
  'settings.publication.infrastructure.edit': ['saas_admin'],
  'tenant.users.manage': ['admin', 'saas_admin'],
  'tenant.publish': ['editor', 'admin', 'saas_admin'],
  'billing.view': ['admin', 'saas_admin'],
  'billing.manage': ['admin', 'saas_admin'],
  'platform.ai.config': ['saas_admin'],
  'platform.security.config': ['saas_admin'],
  'platform.legal.config': ['saas_admin'],
  'platform.notifications.manage': ['saas_admin'],
  'platform.support.config': ['saas_admin'],
  'platform.credentials.config': ['saas_admin'],
  'platform.plugins.manage': ['saas_admin'],
  'plugins.view': ['admin', 'saas_admin'],
  'plugins.manage': ['admin', 'saas_admin'],
};

export function hasPanelCapability(role: PanelRole, capability: PanelCapability): boolean {
  return CAPABILITY_ROLES[capability].includes(role);
}
